import _slicedToArray from "/__w/casino-eci88-v2/casino-eci88-v2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useState as o } from "react";
import { useIsoMorphicEffect as r } from './use-iso-morphic-effect.js';
function i(t) {
  var n;
  if (t.type) return t.type;
  var e = (n = t.as) != null ? n : "button";
  if (typeof e == "string" && e.toLowerCase() === "button") return "button";
}
function s(t, e) {
  var _o = o(function () {
      return i(t);
    }),
    _o2 = _slicedToArray(_o, 2),
    n = _o2[0],
    u = _o2[1];
  return r(function () {
    u(i(t));
  }, [t.type, t.as]), r(function () {
    n || e.current && e.current instanceof HTMLButtonElement && !e.current.hasAttribute("type") && u("button");
  }, [n, e]), n;
}
export { s as useResolveButtonType };